export const selectStyles = (isDark, getColorById) => ({
  control: (base, state) => ({
    ...base,
    backgroundColor: isDark ? '#18181b' : '#fff',
    borderColor: state.isFocused ? '#3b82f6' : isDark ? '#52525b' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
    color: isDark ? '#fff' : '#374151',
    ...(isDark ? { background: '#18181b !important', backgroundColor: '#18181b !important' } : { background: '#fff !important', backgroundColor: '#fff !important' }),
    '&:hover': {
      borderColor: '#3b82f6'
    }
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: isDark ? '#18181b' : '#fff',
    border: `1px solid ${isDark ? '#52525b' : '#d1d5db'}`
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused
      ? (isDark ? '#27272a' : '#f3f4f6')
      : 'transparent',
    color: isDark ? '#fff' : '#374151',
    '&:active': {
      backgroundColor: isDark ? '#27272a' : '#f3f4f6'
    }
  }),
  multiValue: (base, state) => {
    const color = getColorById ? getColorById(state.data.value) : null;
    return {
      ...base,
      backgroundColor: color ? color.color_code : (isDark ? '#27272a' : '#f3f4f6'),
      color: color ? (isColorDark(color.color_code) ? '#ffffff' : '#000000') : (isDark ? '#fff' : '#374151')
    };
  },
  multiValueLabel: (base, state) => {
    const color = getColorById ? getColorById(state.data.value) : null;
    return {
      ...base,
      color: color ? (isColorDark(color.color_code) ? '#ffffff' : '#000000') : (isDark ? '#fff' : '#374151')
    };
  },
  multiValueRemove: (base, state) => {
    const color = getColorById ? getColorById(state.data.value) : null;
    return {
      ...base,
      color: color ? (isColorDark(color.color_code) ? '#ffffff' : '#000000') : (isDark ? '#fff' : '#374151'),
      ':hover': {
        backgroundColor: color ? (isColorDark(color.color_code) ? '#ffffff20' : '#00000020') : (isDark ? '#27272a' : '#e5e7eb'),
        color: color ? (isColorDark(color.color_code) ? '#ffffff' : '#000000') : (isDark ? '#fff' : '#374151')
      }
    };
  },
  singleValue: (base) => ({
    ...base,
    color: isDark ? '#fff' : '#374151'
  }),
  input: (base) => ({
    ...base,
    color: isDark ? '#fff' : '#374151'
  }),
  placeholder: (base) => ({
    ...base,
    color: isDark ? '#a1a1aa' : '#6b7280'
  })
});

const isColorDark = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness < 128;
}; 